module.exports = __webpack_public_path__ + "img/退出全屏.eb7f3c1d.svg";